import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconSuggestionLine = ({ width = 24, height = 24, fill = '#4C5053', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill}
        d="M6.002 13.902h9.963c1.157 0 2.14-.4 2.95-1.202.809-.801 1.214-1.779 1.214-2.932 0-1.154-.405-2.132-1.215-2.933-.81-.802-1.792-1.202-2.949-1.202a.725.725 0 0 0-.534.216.726.726 0 0 0-.216.534c0 .213.072.39.216.534a.725.725 0 0 0 .534.216 2.59 2.59 0 0 1 1.886.764c.518.51.778 1.133.778 1.871a2.52 2.52 0 0 1-.778 1.87 2.592 2.592 0 0 1-1.886.764H6.002l3.182-3.17a.729.729 0 0 0 .223-.518.692.692 0 0 0-.22-.537.723.723 0 0 0-.526-.206.7.7 0 0 0-.52.208l-4.37 4.33a.88.88 0 0 0-.271.64c0 .243.09.455.271.636l4.37 4.33c.148.15.322.22.521.214a.757.757 0 0 0 .522-.229.76.76 0 0 0 .225-.527.68.68 0 0 0-.225-.527l-3.182-3.144Z"
      />
    </Svg>
  );
};

export default IconSuggestionLine;
